import { render, staticRenderFns } from "./TarjetaReparacion.vue?vue&type=template&id=1954daba&scoped=true"
import script from "./TarjetaReparacion.vue?vue&type=script&lang=js"
export * from "./TarjetaReparacion.vue?vue&type=script&lang=js"
import style0 from "./TarjetaReparacion.vue?vue&type=style&index=0&id=1954daba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1954daba",
  null
  
)

export default component.exports